import Title from './Title';
import './tools.css';
import { Link } from 'react-router-dom';
import { Card, CardMedia } from '@mui/material';

function Tools() {
  return (
    <div>
      <Title title={'Tools'} />

      <div className="toolsrow">
        <div className="toolcard">
          <Link to="/tools/postage-calculator" style={{ textDecoration: 'none' }}>
            <Card>
              <CardMedia component="img" image="/toolpic/pic1.jpg" />
              <h4 className="nekopara" style={{marginLeft:"6%"}}>China Post International Ordinary Mail Rate Calculator</h4>
            </Card>
          </Link>
        </div>

        <div className="toolcard">
          <a href="https://cfips.sadatsunemyspace.uk" style={{ textDecoration: 'none' }}>
            <Card>
              <CardMedia component="img" image="/toolpic/pic2.jpg" />
              <h4 className="nekopara" style={{marginLeft:"6%"}}>Cloudflare Premium IPs for Proxy</h4>
            </Card>
          </a>
        </div>

        <div className="toolcard">
          <a href="https://rsa.sadatsunemyspace.uk" style={{ textDecoration: 'none' }}>
            <Card>
              <CardMedia component="img" image="/toolpic/pic3.png" />
              <h4 className="nekopara" style={{marginLeft:"6%"}}>RSA Key Pairs Online Generator</h4>
            </Card>
          </a>
        </div>

        <div className="toolcard">
          <Link to="/tools/remit-loss-calculator" style={{ textDecoration: 'none' }}>
            <Card>
              <CardMedia component="img" image="/toolpic/pic4.jpg" />
              <h4 className="nekopara" style={{marginLeft:"6%"}}>
              CN banks to HK banks via FPS, HK banks to Canadian banks via WISE remit loss calculator
              </h4>
            </Card>
          </Link>
        </div>
      </div>

      <div style={{ height: '120px' }} />
    </div>
  );
}

export default Tools;
